@if (remapFrom) {
  <div class="form-container" [formGroup]="remapFrom">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Name </label>
          </div>
          <clickatell-form-validation [controlName]="'name'"
          [form]="remapFrom"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="remapFrom" id="name"
            [formControlName]="'name'" placeholder="Enter name"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <clickatell-form-validation [controlName]="'description'"
            [form]="remapFrom"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="remapFrom" id="description"
              [formControlName]="'description'" placeholder="Enter description"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Value To Remap</label>
              </div>
              <clickatell-form-validation [controlName]="'valueToRemap'"
              [form]="remapFrom"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="remapFrom" id="variableName"
                [formControlName]="'valueToRemap'" placeholder="Enter value to remap"/>
              </div>
            </ng-container>
          </clickatell-expansion-panel>
          <clickatell-expansion-panel>
            <ng-container header>
              <mat-panel-title>
                Remap
              </mat-panel-title>
            </ng-container>
            <ng-container body>
              <div class="control-div">
                @for (remapValues of remapFrom.controls.remapValues.controls; track remapValues; let index = $index) {
                  <div class="control-container" [formGroup]="remapValues">
                    <span class="control-container-header">
                      <label class="label">
                        Value
                      </label>
                      <img class="deleteBtn" src="../../../../../../../../assets/svg/delete-bin.svg"
                        alt="delete variable" (click)="deleteRemapValue(index)">
                      </span>
                      <clickatell-form-validation [controlName]="'key'"
                      [form]="remapValues"></clickatell-form-validation>
                      <input class="control-input control-container-variable" [formControlName]="'key'"
                        placeholder="key"/>
                        <clickatell-form-validation [controlName]="'value'"
                        [form]="remapValues"></clickatell-form-validation>
                        <input class="control-input control-container-variable" [formControlName]="'value'"
                          placeholder="Value"/>
                        </div>
                      }
                      <div class="control-add-button">
                        <button [disabled]="!canEdit" (click)="addRemapValue()">
                          Add New Value
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </clickatell-expansion-panel>
                <clickatell-expansion-panel>
                  <ng-container header>
                    <mat-panel-title>
                      Logic
                    </mat-panel-title>
                  </ng-container>
                  <ng-container body>
                    <div class="control-result">
                      <div class="control-result-header">
                        Yes
                      </div>
                      <div class="control-result-container">
                        <div class="control-div">
                          <label class="control-label">
                            <span class="pont-to">Point To</span>
                            <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                          </label>
                          @if (nodeFlowDetails) {
                            <next-selector [canEditFlows]="canEdit.canEditFlows"
                              [selectorType]="'both'"
                              [flowSteps]="nodeFlowDetails.currentFlowSteps"
                              [flows]="nodeFlowDetails.flows"
                              [name]="'yes'"
                              [form]="remapFrom"
                              [stepId]="nodeFlowDetails.stepId">
                            </next-selector>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="control-result">
                      <div class="control-result-header">
                        No
                      </div>
                      <div class="control-result-container">
                        <div class="control-div">
                          <label class="control-label">
                            <span class="pont-to">Point To</span>
                            <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                          </label>
                          @if (nodeFlowDetails) {
                            <next-selector [canEditFlows]="canEdit.canEditFlows"
                              [selectorType]="'both'"
                              [flowSteps]="nodeFlowDetails.currentFlowSteps"
                              [flows]="nodeFlowDetails.flows"
                              [name]="'no'"
                              [form]="remapFrom"
                              [stepId]="nodeFlowDetails.stepId">
                            </next-selector>
                          }
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </clickatell-expansion-panel>
              </div>
            }


